<template>
  <section class="faqs faqs--sub">
    <h3 class="faqs__head">Subscription FAQS</h3>

    <question 
      v-for="(faq, index) in faqs" 
      :key="index" 
      :question="faq.question"
      :answer="faq.answer"
      />
  </section>
</template>

<script>
import Question from './Question'

export default {
  props: {
    faqs: {
      type: Array, 
      default: []
    }
  },
  components: {
    Question
  }
}
</script>
